import { j as r } from "../../../../jsx-runtime.BREq8dyb.js";
import { memo as a } from "react";
import { b as s } from "../../../../react-hook-form.Du3weLRK.js";
const n = a(({
  children: t,
  onSubmit: o,
  ...m
}) => {
  const {
    handleSubmit: e
  } = s();
  return /* @__PURE__ */ r.jsx("form", { autoComplete: "off", noValidate: !0, ...m, onSubmit: e(o), children: t });
});
n.displayName = "DqDatasetSyncForm";
export {
  n as default
};
//# sourceMappingURL=DqDatasetSyncForm.js.map
